export default {
  hljs: {
    display: 'block',
    overflowX: 'auto',
    padding: '16px',
    paddingRight: '32px',
    background: 'white',
    color: '#282828',
    fontSize: '13px',
    fontFamily: 'Roboto Mono',
    marginTop: '16px',
  },
  'hljs-comment': {
    color: 'rgba(40, 40, 40, 0.6)',
    fontFamily: 'Roboto Mono',
  },
  'hljs-quote': {
    color: 'rgba(40, 40, 40, 0.6)',
    fontFamily: 'Roboto Mono',
  },
  'hljs-keyword': {
    color: '#2568BE',
    fontSize: '13px',
    fontFamily: 'Roboto Mono',
    fontWeight: '500',
  },
  'hljs-selector-tag': {
    color: '#008',
  },
  'hljs-section': {
    color: '#008',
  },
  'hljs-title': {
    color: '#606',
  },
  'hljs-name': {
    color: '#008',
  },
  'hljs-variable': {
    color: '#660',
  },
  'hljs-template-variable': {
    color: '#660',
  },
  'hljs-string': {
    color: '#282828',
    fontSize: '13px',
    fontFamily: 'Roboto Mono',
  },
  'hljs-selector-attr': {
    color: '#080',
  },
  'hljs-selector-pseudo': {
    color: '#080',
  },
  'hljs-regexp': {
    color: '#080',
  },
  'hljs-literal': {
    color: '#E78400',
  },
  'hljs-symbol': {
    color: '#E78400',
  },
  'hljs-bullet': {
    color: '#E78400',
  },
  'hljs-meta': {
    color: '#E78400',
  },
  'hljs-number': {
    color: '#E78400',
    fontSize: '13px',
    fontFamily: 'Roboto Mono',
    fontWeight: '400',
  },
  'hljs-link': {
    color: '#E78400',
  },
  'hljs-doctag': {
    color: '#606',
    fontWeight: 'bold',
  },
  'hljs-type': {
    color: '#606',
  },
  'hljs-attr': {
    color: '#606',
  },
  'hljs-built_in': {
    color: '#606',
  },
  'hljs-builtin-name': {
    color: '#606',
  },
  'hljs-params': {
    color: '#606',
  },
  'hljs-attribute': {
    color: '#000',
  },
  'hljs-subst': {
    color: '#000',
  },
  'hljs-formula': {
    backgroundColor: '#eee',
    fontStyle: 'italic',
  },
  'hljs-selector-id': {
    color: '#9B703F',
  },
  'hljs-selector-class': {
    color: '#9B703F',
  },
  'hljs-addition': {
    backgroundColor: '#baeeba',
  },
  'hljs-deletion': {
    backgroundColor: '#ffc8bd',
  },
  'hljs-strong': {
    fontWeight: 'bold',
  },
  'hljs-emphasis': {
    fontStyle: 'italic',
  },
};
